import { createAction } from "@reduxjs/toolkit";
import type { components } from "../../apis/gen";
import {
	type addSessionResultPayload,
	EventActionTypes,
	type StoreSession,
	type setEventPayload,
	type updateEventPayload,
} from "./events-types";

export const setEvent = createAction<setEventPayload>(
	EventActionTypes.SET_EVENT,
);

export const updateEvent = createAction<updateEventPayload>(
	EventActionTypes.UPDATE_EVENT,
);

export const clearEvent = createAction<string>(EventActionTypes.CLEAR_EVENT);

export const appendSession = createAction<{
	eventId: string;
	session: StoreSession;
}>(EventActionTypes.APPEND_SESSION);

export const addSessionResult = createAction<addSessionResultPayload>(
	EventActionTypes.ADD_SESSION_RESULT,
);

export const addSessionHighlight = createAction<{
	eventId: string;
	sessionIdx: number;
	highlight: components["schemas"]["HighlightStatus"];
}>(EventActionTypes.ADD_SESSION_HIGHLIGHT);

export const updateSessionHighlight = createAction<{
	eventId: string;
	sessionIdx: number;
	highlightIdx: number;
	updates: Partial<components["schemas"]["HighlightStatus"]>;
}>(EventActionTypes.UPDATE_SESSION_HIGHLIGHT);

export const eventBooked = createAction<{
	eventId: string;
	at: string;
	userId: string;
}>(EventActionTypes.EVENT_BOOKED);

export const eventCheckedIn = createAction<{
	eventId: string;
	at: string;
}>(EventActionTypes.EVENT_CHECKED_IN);

export const sessionStreamReady = createAction<{
	eventId: string;
	sessionIdx: number;
	streamUrl: string;
}>(EventActionTypes.SESSION_STREAM_READY);

export const sessionSharelinkReady = createAction<{
	eventId: string;
	sessionIdx: number;
	url: string;
}>(EventActionTypes.SESSION_SHARELINK_READY);

export const sessionProcessingDone = createAction<{
	eventId: string;
	sessionIdx: number;
}>(EventActionTypes.SESSION_PROCESSING_DONE);

export const sessionArchived = createAction<{
	eventId: string;
	sessionIdx: number;
}>(EventActionTypes.SESSION_ARCHIVED);
